<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          title="CTQ 週報下載"
          class="card-padding v-card__first"
          color="general"
        >
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  lg2>
                  <v-menu
                    v-model="summaryDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryDateStart"
                      label="日期"
                      prepend-icon="event"
                      readonly
                    />
                    <v-date-picker
                      v-model="summaryDateStart"
                      :min="'2025-01-01'"
                      :max="dayPickerMax"
                      :color="theme==='dark'?'danger':'general'"
                      :first-day-of-week="1"
                      no-title
                      scrollable
                    />
                  </v-menu>
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mix-btn black text-light"
                    @click="doWeeklyExport()"
                  >
                    <v-icon class="float-left mr-1">mdi-download</v-icon>下載週報
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import qs from 'qs'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'CTQWeeklyExport',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      summaryDateMenu: false,
      summaryDateStart: ''
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    dayPickerMax () {
      return this.$moment(new Date()).format('YYYY-MM-DD')
    }
  },
  watch: {
    summaryDateStart (val) {
      if (val) {
        this.summaryDateMenu = false
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/ctqThermalPerformance/CTQWeeklyExport')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          this.summaryDateStart = this.dayPickerMax
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    doWeeklyExport () {
      if (!this.summaryDateStart) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇日期'
        return
      }
      const date = String(this.summaryDateStart).substr(0, 10)
      if (!date) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '無法解析日期'
        return
      }
      this.loadingView = true
      this.$http.get('/api/thermalModule/ctq/weekly/exportByManufactureDate?' + qs.stringify({ date }), { responseType: 'blob' })
        .then(res => {
          this.loadingView = false
          console.info(res)
          const blobData = res.data
          const isBlob = blobData instanceof Blob
          if (res.status === 200 && isBlob && blobData.type === 'application/json') {
            return new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onload = () => {
                let parsed = {}
                try {
                  parsed = JSON.parse(reader.result)
                } catch (e) {
                  parsed = {}
                }
                this.snackbar = true
                this.snackbarColor = 'red'
                this.snackbarMsg = parsed.errMsg || '下載失敗'
              }
              reader.onerror = () => {
                reject(blobData)
              }
              reader.readAsText(blobData)
            })
          } else if (res.status === 200 && isBlob) {
            const blob = new Blob([blobData], {
              type: blobData.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url = window.URL.createObjectURL(blob)
            const downloadLink = document.createElement('a')
            downloadLink.href = url
            downloadLink.download = this.weeklyExportFileName(date)
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
            window.URL.revokeObjectURL(url)
          } else {
            this.snackbar = true
            this.snackbarColor = 'red'
            this.snackbarMsg = '下載失敗，請通知系統管理員'
          }
        })
        .catch(err => {
          this.loadingView = false
          this.snackbar = true
          this.snackbarColor = 'orange'
          this.snackbarMsg = err
        })
    },
    weeklyExportFileName (date) {
      let year = ''
      let week = ''
      if (date && this.$moment) {
        const m = this.$moment(date)
        year = String(m.isoWeekYear())
        week = this.pad(m.isoWeek())
      }
      const sent = this.$moment ? this.$moment().format('YYYYMMDDHHmmss') : ''
      return year + 'W' + week + '_Weekly_CTQ_thermal_report_' + sent + '.xlsx'
    },
    pad (n) {
      return String(n).padStart(2, '0')
    }
  }
}
</script>
